var map = {
	"./aichi.png": "e345",
	"./akita.png": "7c57",
	"./aomori.png": "141c",
	"./chiba.png": "2713",
	"./ehime.png": "c4c0",
	"./fukui.png": "4aae",
	"./fukuoka.png": "24e2",
	"./fukushima.png": "2ccd",
	"./gifu.png": "1819",
	"./gunma.png": "dd20",
	"./hiroshima.png": "2123",
	"./hokkaido.png": "dc6c",
	"./hyogo.png": "0f7c",
	"./ibaraki.png": "d14e",
	"./ishikawa.png": "07a0",
	"./iwate.png": "c035",
	"./kagawa.png": "e62c",
	"./kagoshima.png": "b667",
	"./kanagawa.png": "da36",
	"./kochi.png": "5f42",
	"./kumamoto.png": "e61a",
	"./kyoto.png": "d901",
	"./mie.png": "838e",
	"./miyagi.png": "e939",
	"./miyazaki.png": "6e94",
	"./nagano.png": "9f41",
	"./nagasaki.png": "c5c3",
	"./nara.png": "7dfd",
	"./niigata.png": "a650",
	"./oita.png": "9555",
	"./okayama.png": "8094",
	"./okinawa.png": "cbc8",
	"./osaka.png": "91e3",
	"./saga.png": "b65c",
	"./saitama.png": "a8d2",
	"./shape_roulette_anime.gif": "f397",
	"./shiga.png": "f6cd",
	"./shimane.png": "33c3",
	"./shizuoka.png": "d743",
	"./tochigi.png": "725a",
	"./tokushima.png": "5112",
	"./tokyo.png": "93bf",
	"./tottori.png": "662b",
	"./toyama.png": "a8d9",
	"./wakayama.png": "8f20",
	"./yamagata.png": "d633",
	"./yamaguchi.png": "05c4",
	"./yamanashi.png": "9b33"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd7c";